import React from "react";
import "./footer.css";
import qrImg from "../../assets/qr.png";

const Footer = ({ games = [], jpl, jpc, jpg }) => {
  const items =
    games &&
    games.map((game, index) => (
      <div
        className="ticker-item"
        key={`footer-item-${index}-${game.away.team}-${game.home.team}`}
      >
        <div className="team-row">
          <div className={`team-line ${game.away.runs > game.home.runs ? "winner-text" : "normal-text"}`}>
            {game.away.team}&nbsp;&nbsp;{game.away.runs}&nbsp;&nbsp;{game.away.so}k
          </div>
        </div>
        <div className="team-row">
          <div className={`team-line ${game.home.runs > game.away.runs ? "winner-text" : "normal-text"}`}>
            {game.home.team}&nbsp;&nbsp;{game.home.runs}&nbsp;&nbsp;{game.home.so}k
          </div>
        </div>
      </div>
    ));

  const items1 =
    games &&
    games.map((game, index) => (
      <div
        className="ticker-item"
        key={`footer-item1-${index}-${game.away.team}-${game.home.team}`}
      >
        <div className="team-row">
          <div className={`team-line ${game.away.runs > game.home.runs ? "winner-text" : "normal-text"}`}>
            {game.away.team}&nbsp;&nbsp;{game.away.runs}&nbsp;&nbsp;{game.away.so}k
          </div>
        </div>
        <div className="team-row">
          <div className={`team-line ${game.home.runs > game.away.runs ? "winner-text" : "normal-text"}`}>
            {game.home.team}&nbsp;&nbsp;{game.home.runs}&nbsp;&nbsp;{game.home.so}k
          </div>
        </div>
      </div>
    ));

  return (
    <div className="ticker-wrapper">
      <div className="footer-event">
        <div className="footer-event-label">
          <span className="font-result">RESULTADOS EVENTO:</span>
        </div>
        <div className="footer-event-number">
          <span className="font-result-num">{games[0]?.event ?? "----"}</span>
        </div>
      </div>

      <div className="ticker-track">
        <div className="ticker-inner">{[...items, ...items1]}</div>
      </div>

      {1 == 2 ? (
        <div className="jackpot jackpot-qr">
          <div className="jackpot-qr-text">REGISTRATE Y JUEGA DESDE TU CELULAR 24/7</div>
          <div className="dev-qr">
            <img src={qrImg} width={90} alt="QR" />
          </div>
        </div>
      ) : (
        <div className="jackpot">
          <div className="jp-structure">
            <div className="jp-name">TICKET GANADOR</div>
            <div className="jp-value">{jpc && jpc.ticket !== 0 ? jpc.ticket : "----"}</div>
          </div>

          <div className="jp-structure">
            <div className="jp-name">JACKPOT</div>
            <div className="jp-value">{jpc ? jpc.value.toLocaleString("en-EN") : "----"}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;